import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AboutLayout from './layout/AboutLayout';
import MainLayout from './layout/MainLayout';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import useMediaQuery from "@mui/material/useMediaQuery";
import { ToastContainer } from 'react-toastify';


function App() {

  const vMediaQuery = useMediaQuery("(max-width:600px)");

  const theme = createTheme({
    typography: {
      subtitle1: {
        fontFamily: "EB Garamond",
        fontWeight: 400,
        fontSize: vMediaQuery ? "16px" : "17px",
      },
      body1: {
        fontFamily: "EB Garamond",
        fontWeight: 400,
        fontSize: vMediaQuery ? "16px" : "17px",
      },
      body2: {
        fontFamily: "EB Garamond",
        fontWeight: 400,
        fontSize: vMediaQuery ? "16px" : "17px",
      },
      button: {
        fontFamily: "EB Garamond",
        fontWeight: 400,
        fontSize: vMediaQuery ? "16px" : "17px",
      },
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <ToastContainer />
      <Router>
        <Routes>
          <Route path="/" element={<MainLayout />} />
          <Route path="/about" element={<AboutLayout />} />
          {/* Add more routes here if needed */}
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
